import { render, staticRenderFns } from "./RequestChangeEmail.vue?vue&type=template&id=143168b6&"
import script from "./RequestChangeEmail.vue?vue&type=script&lang=ts&"
export * from "./RequestChangeEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports